import { ChildId } from 'types';
import StaffHTTPService from 'services/HTTPService/staff/StaffHTTPService';
import { Col, Divider } from 'antd';

import { useAppQuery } from 'services/reactQuery/useAppQuery';
import { InvoiceCorrectionUploadElement } from 'components/molecules/FormElements/InvoiceCorrectionUploadElement/InvoiceCorrectionUploadElement';
import { AppForm } from 'components/organisms';
import { settlementTexts } from 'consts/text';
import { useIsMobile } from 'hooks/useIsMobile/useIsMobile';
import { ChildSettlementComponents } from '../../ChildSettlementComponents/ChildSettlementComponents';
import { ChildCorrectionInvoices } from '../../ChildCorrectionInvoices/ChildCorrectionInvoices';
import { ChildSettlementCostSplitList } from '../../ChildSettlementCostSplitList/ChildSettlementCostSplitList';
import { If } from '../../../../atoms/If/If';

type Props = {
    childId: ChildId;
    selectedYear: number;
    selectedMonth: number;
};

export const ChildSettlementsCorrections = ({ childId, selectedMonth, selectedYear }: Props) => {
    const yearMonth = `${selectedYear}-${selectedMonth.toString().padStart(2, '0')}`;
    const isMobile = useIsMobile();

    const { data: childSettlement } = useAppQuery(
        'CHILD_SETTLEMENT',
        [childId, yearMonth],
        () =>
            StaffHTTPService.settlements.getChildSettlement({
                childId,
                period: yearMonth,
            }),
        {},
    );
    if (!childSettlement) {
        return null;
    }

    return childSettlement.corrections
        ?.sort((a, b) => b.orderNumber - a.orderNumber)
        .map((correction) => (
            <>
                <Col key={correction.orderNumber}>
                    <ChildSettlementComponents
                        costComponentList={correction.costComponentList}
                        summary={correction.grossSummary}
                        diff={correction.grossAmountDifference}
                        title={`${correction.verified ? 'Korekta' : 'Propozycja korekty'}: ${
                            correction.orderNumber
                        }`}
                    />

                    <If condition={correction.verified}>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: isMobile ? 'column' : 'row',
                                gap: 16,
                                alignItems: 'flex-start',
                                marginTop: -16,
                            }}
                        >
                            <div style={{ flex: 1 }}>
                                <ChildCorrectionInvoices
                                    fileName={correction.fileName}
                                    correctionId={correction.id}
                                />
                            </div>

                            <div style={{ flexShrink: 0, marginTop: 16 }}>
                                <AppForm name="file" withHeader={false} maxWidth={440}>
                                    <InvoiceCorrectionUploadElement
                                        correctionId={correction.id}
                                        label="Dodaj plik korekty"
                                        accept=".pdf"
                                    />
                                </AppForm>
                            </div>
                        </div>
                    </If>

                    <ChildSettlementCostSplitList
                        title={settlementTexts.children.costAllocation.titleCorrection}
                        childId={childId as ChildId}
                        period={yearMonth}
                        isCostSplitModificationDisabled={correction.verified}
                        correctionId={correction.id}
                    />
                </Col>
                <Divider />
            </>
        ));
};
